export default {"src":"/_next/static/media/question_bubble.b1ee5893.svg","height":19,"width":16};